import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI = '[VorlagenModul] PostDokumentLeseBerechtigungHinzufuegenMulti laden';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_AUSFUEHREN = '[VorlagenModul] PostDokumentLeseBerechtigungHinzufuegenMulti ausführen';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_ERFOLGREICH = '[VorlagenModul] PostDokumentLeseBerechtigungHinzufuegenMulti laden erfolgreich';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_FEHLER = '[VorlagenModul] PostDokumentLeseBerechtigungHinzufuegenMulti Ladefehler';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT = '[VorlagenModul] PostDokumentLeseBerechtigungHinzufuegenMulti nicht ausgeführt (evtl. Offline)';


export class PostDokumentLeseBerechtigungHinzufuegenMultiAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI;
        constructor(public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiAusfuehrenAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_AUSFUEHREN;
        constructor(public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiErfolgreichAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.DokumentIdentifier, public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiFehlerAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_FEHLER;
        constructor(public payload: any, public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenCommandDokumentLeseBerechtigungHinzufuegenMultiActions =
    PostDokumentLeseBerechtigungHinzufuegenMultiAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiAusfuehrenAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiErfolgreichAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiFehlerAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiNichtAusgefuehrtAction
    ;
